<template>
  <section class="download-wrapper">
    <section class="title-bar">
      <article class="content-small">
        <h2 class="title">{{ $t("m.get.title") }}</h2>
      </article>
    </section>

    <section class="download-list-wrapper">
      <section class="content-small">
        <article class="download-list">
          <h3 class="download-title">{{ $t("m.get.vr") }}</h3>
          <ul class="btns-container clearfix">
            <li class="download-item">
              <a
                class="download-block"
                target="_blank"
                href="https://www.oculus.com/experiences/quest/2063931653705427/"
              >
                <span class="icon-large">
                  <img
                    src="../assets/images/icon-oculus.png"
                    data-2x=""
                    alt="Oculus Quest"
                  />
                </span>
                <span class="download-item-text"> Oculus Quest </span>
              </a>
            </li>
            <li class="download-item">
              <a
                class="download-block"
                target="_blank"
                href="https://www.oculus.com/experiences/rift/1393269044113553/"
              >
                <span class="icon-large">
                  <img
                    src="../assets/images/icon-oculus.png"
                    data-2x=""
                    alt="Oculus Rift S"
                  />
                </span>
                <span class="download-item-text"> Oculus Rift S </span>
              </a>
            </li>
            <li class="download-item">
              <a
                class="download-block"
                target="_blank"
                href="https://www.oculus.com/experiences/gear-vr/1256687334386627/"
              >
                <span class="icon-large">
                  <img
                    src="../assets/images/icon-oculus.png"
                    data-2x=""
                    alt="Oculus Go"
                  />
                </span>
                <span class="download-item-text"> Oculus Go </span>
              </a>
            </li>
            <li class="download-item">
              <a
                class="download-block"
                target="_blank"
                href="http://store.steampowered.com/app/721090/SKYBOX_VR_Video_Player/"
              >
                <span class="icon-large">
                  <img
                    src="../assets/images/icon-steam.png"
                    data-2x=""
                    alt="Steam VR"
                  />
                </span>
                <span class="download-item-text"> Steam VR </span>
              </a>
            </li>
          </ul>
          <article class="download-list apk">
            <h3 class="download-title">{{ $t("m.get.apk") }}</h3>
            <ul class="btns-container clearfix">
              <li class="download-item">
                <a
                  class="download-block"
                  href="http://download.skybox.xyz/SourceVR_DaydreamVR_0.2.3.3(167).apk"
                >
                  <span class="icon-large">
                    <img
                      src="../assets/images/icon-daydream.png"
                      data-2x=""
                      alt="Daydream"
                    />
                  </span>
                  <span class="download-item-text"> Daydream </span>
                </a>
              </li>
            </ul>
          </article>
        </article>
        <article class="download-list">
          <h3 class="download-title">{{ $t("m.get.pc") }}</h3>
          <ul class="btns-container clearfix">
            <li class="download-item">
                <!-- @click="showWindowWin()" -->
              <a
                class="download-block"
                :href="downloadUrlWin"
              >
                <span class="icon-large">
                  <img
                    src="../assets/images/icon-windows.png"
                    data-2x=""
                    alt="Windows"
                  />
                </span>
                <span class="download-item-text">
                  Windows <span class="addon-text">(64bit)</span>
                </span>
              </a>
            </li>
            <li class="download-item">
              <a class="download-block" @click="showWindow()">
                <span class="icon-large">
                  <img
                    src="../assets/images/icon-apple.png"
                    data-2x=""
                    alt="Mac OS"
                  />
                </span>
                <span class="download-item-text"> Mac OS </span>
              </a>
            </li>
          </ul>
        </article>
      </section>
    </section>

    <section class="version-blog">
      <nav class="content-small">
        <h3 class="title">{{ $t("m.get.note") }}</h3>
        <div
          class="dropdown"
          @click="openList()"
          :style="{ height: listHeight + 'px' }"
        >
          <p class="select">{{ title }}</p>
          <ul class="dropdown-menu">
            <li
              class="option"
              @click="checkOpt('All')"
              :class="{ checked: check == 'all' }"
              data-value="All Platforms"
            >
              {{ $t("m.get.all") }}
            </li>
            <li
              class="option"
              @click="checkOpt('Quest')"
              :class="{ checked: check == 'quest' }"
              data-value="Oculus Quest"
            >
              Oculus Quest / Quest 2
            </li>
            <li
              class="option"
              @click="checkOpt('Rift')"
              :class="{ checked: check == 'rift' }"
              data-value="Oculus Rift / Rift S"
            >
              Oculus Rift / Rift S
            </li>
            <li
              class="option"
              :class="{ checked: check == 'steam' }"
              @click="checkOpt('Steam')"
              data-value="Steam VR"
            >
              Steam VR
            </li>
            <li
              class="option"
              :class="{ checked: check == 'pc' }"
              @click="checkOpt('PC')"
              data-value="PC / Mac Client"
            >
              PC / Mac Client
            </li>
          </ul>
        </div>
      </nav>
      <article class="download-content">
        <section class="blog-container">
          <div class="dropdown-content-all-platforms">
            <dl v-for="(item, index) in notes" :key="index">
              <dl
                class="blog-item"
                v-if="item.check == check || check == 'all'"
              >
                <dt class="blog-title">
                  {{ item.title }} <br />
                  <span class="release-time"
                    >{{ $t("m.get.release") }} {{ item.time }}
                  </span>
                </dt>
                <ul>
                  <li v-html="item.content"></li>
                </ul>
              </dl>
            </dl>

            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 1.0.5 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Oct 08, 2021
                </span>
              </dt>
              <ul>
                <li>
                  [Bug Fixes] Fixed Samba-related bugs and improved Samba
                  stability
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 1.0.4 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jul 29, 2021
                </span>
              </dt>
              <ul>
                <li>
                  [New Feature] Global Setting: In-App Hand Tracking (Support
                  Select, Scroll, Drag Screen and Exit)
                </li>
              </ul>
              <ul>
                <li>[New Feature] Hand Tracking Mini Bar During Playback</li>
              </ul>
              <ul>
                <li>
                  [New Feature] Advanced Setting: VR Video Rotation
                  -90°/0°/90°/180°
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 1.0.3.1 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jun 18, 2021
                </span>
              </dt>
              <ul>
                <li>
                  [New Feature] Report Bug to Devs Using the Feedback Button
                </li>
              </ul>
              <ul>
                <li>[New Feature] Update Notification</li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 1.0.3 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} May 09, 2021
                </span>
              </dt>
              <ul>
                <li>
                  [New Feature] 90Hz Refresh Rate on Quest 2 (adjustment
                  provided in Global Setting)
                </li>
              </ul>
              <ul>
                <li>
                  [Bug Fixed] Fixed the issue that while trying to open the
                  interface during VR video playback, the screen would be
                  dragged instead.
                </li>
              </ul>
              <ul>
                <li>[Optimization] Bluetooth Sync Ranges from -2s to 2s</li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 1.0.2 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Mar 29, 2021
                </span>
              </dt>
              <ul>
                <li>[Fixed Bug] Fixed SMB crash issues.</li>
              </ul>
              <ul>
                <li>[Fixed Bug] Fixed some DLNA servers cannot be found.</li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed SMB cannot remember username/password issue.
                </li>
              </ul>
              <ul>
                <li>[New Feature] Support SMBv3.</li>
              </ul>
              <ul>
                <li>[New Feature] Support manually input SMB IP address.</li>
              </ul>
              <ul>
                <li>
                  [Optimization] Optimize the Button B/Y's function of
                  cancelling and returning to previous page.
                </li>
              </ul>
              <ul>
                <li>[Optimization] New virtual keyboard layout.</li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="steam">
              <dt class="blog-title">
                Steam VR 0.2.3.4 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Mar 15, 2020
                </span>
              </dt>
              <ul>
                <li>
                  [Feature] Global Setting (in the main hall where you could see
                  mountains outside, look up and a hidden bar would appear):
                </li>
              </ul>
              <ul>
                <li>a. Change language</li>
              </ul>
              <ul>
                <li>B. Clear cache</li>
              </ul>
              <ul>
                <li>c. Adjust fast forwards/backwards interval</li>
              </ul>
              <ul>
                <li>d. Spatial audio</li>
              </ul>
              <ul>
                <li>e. Screen mirroring</li>
              </ul>
              <ul>
                <li>f. Change to 24-hour format</li>
              </ul>
              <ul>
                <li>
                  [Feature] Support space button on keyboard to pause/resume
                </li>
              </ul>
              <ul>
                <li>[Feature] Support picture-based subtitles</li>
              </ul>
              <ul>
                <li>[Feature] Support subtitle font size adjustment</li>
              </ul>
              <ul>
                <li>[Feature] Refresh button on local directories</li>
              </ul>
              <ul>
                <li>
                  [Feature] Long press B/Y button (on Rift/Rift S) to reset the
                  screen (available in Void/Moon/Space Station theatre and 180
                  videos)
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Do not generate thumbnails during video
                  playback
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Keep the browse location when deleting files or
                  return to parent directory
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Continuous fast forwards/backwards video
                  playback by pushing the joystick to the right/left longer
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.2.3.4 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jan 17, 2020
                </span>
              </dt>
              <ul>
                <li>
                  [Feature] Global Setting (in the main hall where you could see
                  mountains outside, look up and a hidden bar would appear):
                </li>
              </ul>
              <ul>
                <li>a. Change language</li>
              </ul>
              <ul>
                <li>B. Clear cache</li>
              </ul>
              <ul>
                <li>c. Adjust fast forwards/backwards interval</li>
              </ul>
              <ul>
                <li>d. Spatial audio</li>
              </ul>
              <ul>
                <li>e. Screen mirroring</li>
              </ul>
              <ul>
                <li>f. Change to 24-hour format</li>
              </ul>
              <ul>
                <li>
                  [Feature] Support space button on keyboard to pause/resume
                </li>
              </ul>
              <ul>
                <li>[Feature] Support picture-based subtitles</li>
              </ul>
              <ul>
                <li>[Feature] Support subtitle font size adjustment</li>
              </ul>
              <ul>
                <li>[Feature] Refresh button on local directories</li>
              </ul>
              <ul>
                <li>
                  [Feature] Long press B/Y button to reset the screen (available
                  in Void/Moon/Space Station theatre and 180 videos)
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Do not generate thumbnails during video
                  playback
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Keep the browse location when deleting files or
                  return to parent directory
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Continuous fast forwards/backwards video
                  playback by pushing the joystick to the right/left longer
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="steam">
              <dt class="blog-title">
                Steam VR 0.2.1 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Nov 26, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Fixed Bug] Fixed some fisheye videos look blurry on the side.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed pixelation on red object during video
                  playback.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed certain 180 videos shoot by Insta360 could
                  be played once only.
                </li>
              </ul>
              <ul>
                <li>[Feature] New Advanced Settings:</li>
              </ul>
              <ul>
                <li>a. Curved Screen</li>
              </ul>
              <ul>
                <li>b. 3D L-R swap</li>
              </ul>
              <ul>
                <li>c. Playback Speed Adjustment</li>
              </ul>
              <ul>
                <li>d. AB loop</li>
              </ul>
              <ul>
                <li>f. Image Adjust - Contrast</li>
              </ul>
              <ul>
                <li>g. Image Adjust - Saturation</li>
              </ul>
              <ul>
                <li>h. Adjust aspect ratio for Full SBS videos</li>
              </ul>
              <ul>
                <li>
                  [Optimization] Support more characters on virtual keyboard (¿
                  ¥ € ￡· ° | ` [ ]).
                </li>
              </ul>
              <ul>
                <li>[Optimization] Always play from last playback point.</li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.2.1 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Nov 15, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Fixed Bug] Fixed some fisheye videos look blurry on the side.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed pixelation on red object during video
                  playback.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed certain 180 videos shoot by Insta360 could
                  be played once only.
                </li>
              </ul>
              <ul>
                <li>[Feature] New Advanced Settings:</li>
              </ul>
              <ul>
                <li>a. Curved Screen</li>
              </ul>
              <ul>
                <li>b. 3D L-R swap</li>
              </ul>
              <ul>
                <li>c. Playback Speed Adjustment</li>
              </ul>
              <ul>
                <li>d. AB loop</li>
              </ul>
              <ul>
                <li>f. Image Adjust - Contrast</li>
              </ul>
              <ul>
                <li>g. Image Adjust - Saturation</li>
              </ul>
              <ul>
                <li>h. Adjust aspect ratio for Full SBS videos</li>
              </ul>
              <ul>
                <li>
                  [Optimization] Support more characters on virtual keyboard (¿
                  ¥ € ￡· ° | ` [ ]).
                </li>
              </ul>
              <ul>
                <li>[Optimization] Always play from last playback point.</li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.2.3 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Oct 31, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Fixed Bug] Fixed that videos cannot be played (show a
                  hourglass) sometimes.
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 0.2.3.3 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Sep 25, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Fixed Bug] Fixed some fisheye videos look blurry on the side.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed pixelation on red object during video
                  playback.
                </li>
              </ul>
              <ul>
                <li>
                  [Feature] Global Setting - Change between 60Hz/72Hz refresh
                  rate.
                </li>
              </ul>
              <ul>
                <li>[Feature] Global Setting - Use 12 or 24 hour format.</li>
              </ul>
              <ul>
                <li>[Feature] Global Setting - Show battery percentage.</li>
              </ul>
              <ul>
                <li>[Feature] Subtitle Setting - Change subtitle size.</li>
              </ul>
              <ul>
                <li>[Feature] Support picture-based subtitles.</li>
              </ul>
              <ul>
                <li>
                  [Feature] Support continuous fast forwards/backwards by moving
                  joystick to the right/left for a longer time.
                </li>
              </ul>
              <ul>
                <li>
                  [Feature] Support reset view (3dof) by holding button B
                  (available for Void/Space/Moon/180 videos).
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Support more characters on virtual keyboard (¿
                  ¥ € ￡· ° | ` [ ]).
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Smoother video playback when in folders with
                  many files via SMB/DLNA.
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Improve the response speed of trigger button.
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="steam">
              <dt class="blog-title">
                Steam VR 0.2.0.2 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jul 22, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Fixed Bug] Fixed reverse video display with certain Fisheye
                  videos.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Display high resolution videos in Directory when
                  using RTX 2070 &amp; RTX 2080.
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.2.0.2 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jul 22, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Optimization] Support manually change audio output between
                  Rift headphones and PC speaker.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed reverse video display with certain Fisheye
                  videos.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Display high resolution videos in Directory when
                  using RTX 2070 &amp; RTX 2080.
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="steam">
              <dt class="blog-title">
                Steam VR 0.2.0.1 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jun 28, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Fixed Bug] Black levels issue in the videos (dark was grey).
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 0.2.3 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jun 17, 2019
                </span>
              </dt>
              <ul>
                <li>[Feature] Support SMBv1.</li>
              </ul>
              <ul>
                <li>[Feature] Change FFR level in Global Setting.</li>
              </ul>
              <ul>
                <li>
                  [Optimization] Turn on/off Spatial Audio in Global Setting.
                </li>
              </ul>
              <ul>
                <li>[Optimization] Faster scrolling in all tabs.</li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 0.2.3 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} May 21, 2019
                </span>
              </dt>
              <ul>
                <li>[New Feature] Spatial audio support.</li>
              </ul>
              <ul>
                <li>
                  [Optimization] Hold “Oculus” button on the controller to reset
                  view.
                </li>
              </ul>
              <ul>
                <li>[Optimizaiton] Use grip button to drag screen.</li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed crash caused by reconnecting AirScreen and
                  improved stability.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Corrected the sorting order for filenames starting
                  with number.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Next 180° VR video appears in the front instead of
                  90 degree on the left.
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.2.2 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Feb 18, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Feature] Playback Speed Control
                  (0.1x/0.25x/0.5x/0.75x/1x/1.25x/1.5x/2x/4x).
                </li>
              </ul>
              <ul>
                <li>[Feature] AB Loop.</li>
              </ul>
              <ul>
                <li>[Feature] Order/Shuffle.</li>
              </ul>
              <ul>
                <li>[Feature] Loop Playlist / Loop One Vide / No Loop.</li>
              </ul>
              <ul>
                <li>
                  [Feature] Filename Recognition for Youtube 360 #EAC360 and
                  Youtube 180 #F180#VR180.
                </li>
              </ul>
              <ul>
                <li>
                  [Optimisation] Mute PC/Mac when turning off Screen Mirroring.
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.2.0.1 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jan 24, 2019
                </span>
              </dt>
              <dd class="blog-detail">
                [Fixed Bug] Black levels issue in the videos (dark was grey).
              </dd>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.2.1 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jan 09, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Feature] Folder mode (allow organising files in folders).
                </li>
              </ul>
              <ul>
                <li>[Feature] Clear invalid files with one click.</li>
              </ul>
              <ul>
                <li>[Feature] Find file in Folder mode.</li>
              </ul>
              <ul>
                <li>[Feature] Open file physical location.</li>
              </ul>
              <ul>
                <li>[Feature] Select and remove more than one file.</li>
              </ul>
              <ul>
                <li>[Feature] Sort by Time.</li>
              </ul>
              <ul>
                <li>[Feature] List View.</li>
              </ul>
              <ul>
                <li>
                  [Optimization] Load files displayed on the current page first.
                </li>
              </ul>
              <ul>
                <li>[Optimisation] Load file first when clicking on it.</li>
              </ul>
              <ul>
                <li>[Fixed bug] Filename recognition for 2D and 3D videos.</li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="steam">
              <dt class="blog-title">
                Steam VR 0.2.0 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jan 09, 2019
                </span>
              </dt>
              <ul>
                <li>[Feature] Support deleting video files within SKYBOX.</li>
              </ul>
              <ul>
                <li>[Feature] View by List.</li>
              </ul>
              <ul>
                <li>
                  [Feature] Shortcuts to frequently-used folders (Pin Folder).
                </li>
              </ul>
              <ul>
                <li>[Feature] Sorting by Name/Size/Time.</li>
              </ul>
              <ul>
                <li>[Feature] Manually adapt to Youtube 360 (EAC).</li>
              </ul>
              <ul>
                <li>[Feature] Support Youtube 180 (Fisheye) videos.</li>
              </ul>
              <ul>
                <li>
                  [Feature] Display full filename when cursor hovers over a
                  video.
                </li>
              </ul>
              <ul>
                <li>
                  [Feature] Double click the controller button to pause and
                  resume playback.
                </li>
              </ul>
              <ul>
                <li>[Feature] New cinema scene "Moon".</li>
              </ul>
              <ul>
                <li>[Feature] Lighting adjustment in Movie Theatre Scene.</li>
              </ul>
              <ul>
                <li>[Feature] Seat change in Movie Theatre Scene.</li>
              </ul>
              <ul>
                <li>[Feature] SMB support.</li>
              </ul>
              <ul>
                <li>[Feature] Auto play next video on the playlist.</li>
              </ul>
              <ul>
                <li>
                  [Feature] Adjustment for eye distance (offset) for 3D videos.
                </li>
              </ul>
              <ul>
                <li>
                  [Feature] Support filling in SMB username/password using
                  keyboard.
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Upgrade player engine for improved playback
                  performance and compatibility.
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Optimize format recognition engine to improve
                  recognition accuracy.
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.2.0 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Nov 27, 2018
                </span>
              </dt>
              <dd class="blog-detail">Add cinema scene "Moon".</dd>
              <dd class="blog-detail">
                Lighting adjustment in the Movie Theatre Scene.
              </dd>
              <dd class="blog-detail">
                Seat change in the Movie Theatre Scene.
              </dd>
              <dd class="blog-detail">SMB support.</dd>
              <dd class="blog-detail">Support Youtube 180 (Fisheye) videos.</dd>
              <dd class="blog-detail">Auto play next video on the playlist.</dd>
              <dd class="blog-detail">Zoom boost to 350%.</dd>
              <dd class="blog-detail">
                Adjustment for eye distance (offset) for 3D videos.
              </dd>
              <dd class="blog-detail">
                Support filling in SMB username/password using keyboard.
              </dd>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.1.7.4 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Sep 19, 2018
                </span>
              </dt>
              <dd class="blog-detail">
                Fixed a javascript crashing bug for Windows.
              </dd>
              <dd class="blog-detail">
                Prevent computer from sleeping ONLY when videos are playing or
                devices connected.
              </dd>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.1.9 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Aug 13, 2018
                </span>
              </dt>
              <dd class="blog-detail">
                Upgrade player engine for improved playback performance and
                compatibility.
              </dd>
              <dd class="blog-detail">
                Optimize the format recognition engine to improve recognition
                accuracy.
              </dd>
              <dd class="blog-detail">
                Display entire filename when cursor hovers over a video.
              </dd>
              <dd class="blog-detail">
                Double click the controller button to pause and resume playback.
              </dd>
            </dl>

            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.1.7.3 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jun 19, 2018
                </span>
              </dt>
              <dd class="blog-detail">Fixed some bugs.</dd>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.1.7.2 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} May 25, 2018
                </span>
              </dt>
              <dd class="blog-detail">Fixed a runtime error.</dd>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.1.7.1 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Apr 08, 2018
                </span>
              </dt>
              <dd class="blog-detail">Add support for iOS device.</dd>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.1.8 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Feb 01, 2018
                </span>
              </dt>
              <dd class="blog-detail">
                Support deleting video files within SKYBOX.
              </dd>
              <dd class="blog-detail">
                Support the new list display mode for videos and folders.
              </dd>
              <dd class="blog-detail">
                Support creating folder shortcuts to the Channels.
              </dd>
              <dd class="blog-detail">
                Support sorting by file name, size, time in Directory.
              </dd>
              <dd class="blog-detail">
                Support manually adapting to YouTube-360-video format (EAC).
              </dd>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.1.7 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jan 19, 2018
                </span>
              </dt>
              <dd class="blog-detail">Optimize video recognition process.</dd>
              <dd class="blog-detail">
                Optimize streaming for multiple devices.
              </dd>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.1.7 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jan 08, 2018
                </span>
              </dt>
              <dd class="blog-detail">
                Improved accuracy for automatic video stereo mode recognition.
              </dd>
              <dd class="blog-detail">Optimized long filename truncation.</dd>
              <dd class="blog-detail">
                Optimized screen scaling animation during playback.
              </dd>
            </dl>
            <dl class="blog-item" v-if="steam">
              <dt class="blog-title">
                Steam VR 0.1.7 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jan 08, 2018
                </span>
              </dt>
              <dd class="blog-detail">
                Improved accuracy for automatic video stereo mode recognition.
              </dd>
              <dd class="blog-detail">Optimized long filename truncation.</dd>
              <dd class="blog-detail">
                Optimized screen scaling animation during playback.
              </dd>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.1.6 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Dec 07, 2017
                </span>
              </dt>
              <dd class="blog-detail">
                Support streaming videos from UPnP/DLNA servers.
              </dd>
              <dd class="blog-detail">
                Support hiding and locking all your private folds/files with one
                password.
              </dd>
              <dd class="blog-detail">
                Support manual time adjustment of audio and subtitles.
              </dd>
              <dd class="blog-detail">
                Support 'screen locking' with regular flatscreen videos to keep
                the screen always in front of you.
              </dd>
              <dd class="blog-detail">
                Optimized the UI of playback control panel for easier playback
                controls.
              </dd>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.1.4 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Nov 07, 2017
                </span>
              </dt>
              <dd class="blog-detail">Support Arabic and Hebrew subtitles.</dd>
              <dd class="blog-detail">
                Support playing videos with SKYBOX when browsing files with
                third party file management tools.
              </dd>
              <dd class="blog-detail">
                Fixed stutters during playback of MPEG2 and MPEG4 encoded
                videos.
              </dd>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.1.3 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Oct 07, 2017
                </span>
              </dt>
              <dd class="blog-detail">
                Support subtitles and audio track selection. (Subtitle files
                should be put under the same directory and has the same filename
                as the video.)
              </dd>
              <dd class="blog-detail">Support file directory browsing.</dd>
              <dd class="blog-detail">
                Added new theatre scene 'Space Station'.
              </dd>
              <dd class="blog-detail">
                Added new way to adjust the position (dragging) and size
                (sliding on touchpad) of the screen in the 'Void' theatre mode.
              </dd>
            </dl>

            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.1.6 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Sep 14, 2017
                </span>
              </dt>
              <dd class="blog-detail">
                Videos can be played/paused/stopped in list view by context
                menu.
              </dd>
              <dd class="blog-detail">Moved orignal player to preview view.</dd>
              <dd class="blog-detail">
                Optimized search time for subtitles of large amount videos.
              </dd>
              <dd class="blog-detail">
                Optimized network connection for AirScreen.
              </dd>
              <dd class="blog-detail">Fixed several crashes.</dd>
              <dd class="blog-detail">
                Fixed video's info cannot be gotten in serveral types of video.
              </dd>
              <dd class="blog-detail">Fixed several UI bugs.</dd>
            </dl>
          </div>

          <div class="dropdown-content-oculus-quest" style="display: none">
            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 1.0.4 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jul 29, 2021
                </span>
              </dt>
              <ul>
                <li>
                  [New Feature] Global Setting: In-App Hand Tracking (Support
                  Select, Scroll, Drag Screen and Exit)
                </li>
              </ul>
              <ul>
                <li>[New Feature] Hand Tracking Mini Bar During Playback</li>
              </ul>
              <ul>
                <li>
                  [New Feature] Advanced Setting: VR Video Rotation
                  -90°/0°/90°/180°
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 1.0.3.1 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jun 18, 2021
                </span>
              </dt>
              <ul>
                <li>
                  [New Feature] Report Bug to Devs Using the Feedback Button
                </li>
              </ul>
              <ul>
                <li>[New Feature] Update Notification</li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 1.0.3 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} May 09, 2021
                </span>
              </dt>
              <ul>
                <li>
                  [New Feature] 90Hz Refresh Rate on Quest 2 (adjustment
                  provided in Global Setting)
                </li>
              </ul>
              <ul>
                <li>
                  [Bug Fixed] Fixed the issue that while trying to open the
                  interface during VR video playback, the screen would be
                  dragged instead.
                </li>
              </ul>
              <ul>
                <li>[Optimization] Bluetooth Sync Ranges from -2s to 2s</li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 1.0.2 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Mar 29, 2021
                </span>
              </dt>
              <ul>
                <li>[Fixed Bug] Fixed SMB crash issues.</li>
              </ul>
              <ul>
                <li>[Fixed Bug] Fixed some DLNA servers cannot be found.</li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed SMB cannot remember username/password issue.
                </li>
              </ul>
              <ul>
                <li>[New Feature] Support SMBv3.</li>
              </ul>
              <ul>
                <li>[New Feature] Support manually input SMB IP address.</li>
              </ul>
              <ul>
                <li>
                  [Optimization] Optimize the Button B/Y's function of
                  cancelling and returning to previous page.
                </li>
              </ul>
              <ul>
                <li>[Optimization] New virtual keyboard layout.</li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 0.2.3.3 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Sep 25, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Fixed Bug] Fixed some fisheye videos look blurry on the side.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed pixelation on red object during video
                  playback.
                </li>
              </ul>
              <ul>
                <li>
                  [Feature] Global Setting - Change between 60Hz/72Hz refresh
                  rate.
                </li>
              </ul>
              <ul>
                <li>[Feature] Global Setting - Use 12 or 24 hour format.</li>
              </ul>
              <ul>
                <li>[Feature] Global Setting - Show battery percentage.</li>
              </ul>
              <ul>
                <li>[Feature] Subtitle Setting - Change subtitle size.</li>
              </ul>
              <ul>
                <li>[Feature] Support picture-based subtitles.</li>
              </ul>
              <ul>
                <li>
                  [Feature] Support continuous fast forwards/backwards by moving
                  joystick to the right/left for a longer time.
                </li>
              </ul>
              <ul>
                <li>
                  [Feature] Support reset view (3dof) by holding button B
                  (available for Void/Space/Moon/180 videos).
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Support more characters on virtual keyboard (¿
                  ¥ € ￡· ° | ` [ ]).
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Smoother video playback when in folders with
                  many files via SMB/DLNA.
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Improve the response speed of trigger button.
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 0.2.3 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jun 17, 2019
                </span>
              </dt>
              <ul>
                <li>[Feature] Support SMBv1.</li>
              </ul>
              <ul>
                <li>[Feature] Change FFR level in Global Setting.</li>
              </ul>
              <ul>
                <li>
                  [Optimization] Turn on/off Spatial Audio in Global Setting.
                </li>
              </ul>
              <ul>
                <li>[Optimization] Faster scrolling in all tabs.</li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="quest">
              <dt class="blog-title">
                Oculus Quest 0.2.3 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} May 21, 2019
                </span>
              </dt>
              <ul>
                <li>[New Feature] Spatial audio support.</li>
              </ul>
              <ul>
                <li>
                  [Optimization] Hold “Oculus” button on the controller to reset
                  view.
                </li>
              </ul>
              <ul>
                <li>[Optimizaiton] Use grip button to drag screen.</li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed crash caused by reconnecting AirScreen and
                  improved stability.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Corrected the sorting order for filenames starting
                  with number.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Next 180° VR video appears in the front instead of
                  90 degree on the left.
                </li>
              </ul>
            </dl>
          </div>
          <div class="dropdown-content-steam-vr" style="display: none">
            <dl class="blog-item" v-if="steam">
              <dt class="blog-title">
                Steam VR 0.2.3.4 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Mar 15, 2020
                </span>
              </dt>
              <ul>
                <li>
                  [Feature] Global Setting (in the main hall where you could see
                  mountains outside, look up and a hidden bar would appear):
                </li>
              </ul>
              <ul>
                <li>a. Change language</li>
              </ul>
              <ul>
                <li>B. Clear cache</li>
              </ul>
              <ul>
                <li>c. Adjust fast forwards/backwards interval</li>
              </ul>
              <ul>
                <li>d. Spatial audio</li>
              </ul>
              <ul>
                <li>e. Screen mirroring</li>
              </ul>
              <ul>
                <li>f. Change to 24-hour format</li>
              </ul>
              <ul>
                <li>
                  [Feature] Support space button on keyboard to pause/resume
                </li>
              </ul>
              <ul>
                <li>[Feature] Support picture-based subtitles</li>
              </ul>
              <ul>
                <li>[Feature] Support subtitle font size adjustment</li>
              </ul>
              <ul>
                <li>[Feature] Refresh button on local directories</li>
              </ul>
              <ul>
                <li>
                  [Feature] Long press B/Y button (on Rift/Rift S) to reset the
                  screen (available in Void/Moon/Space Station theatre and 180
                  videos)
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Do not generate thumbnails during video
                  playback
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Keep the browse location when deleting files or
                  return to parent directory
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Continuous fast forwards/backwards video
                  playback by pushing the joystick to the right/left longer
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="steam">
              <dt class="blog-title">
                Steam VR 0.2.1 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Nov 26, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Fixed Bug] Fixed some fisheye videos look blurry on the side.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed pixelation on red object during video
                  playback.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed certain 180 videos shoot by Insta360 could
                  be played once only.
                </li>
              </ul>
              <ul>
                <li>[Feature] New Advanced Settings:</li>
              </ul>
              <ul>
                <li>a. Curved Screen</li>
              </ul>
              <ul>
                <li>b. 3D L-R swap</li>
              </ul>
              <ul>
                <li>c. Playback Speed Adjustment</li>
              </ul>
              <ul>
                <li>d. AB loop</li>
              </ul>
              <ul>
                <li>f. Image Adjust - Contrast</li>
              </ul>
              <ul>
                <li>g. Image Adjust - Saturation</li>
              </ul>
              <ul>
                <li>h. Adjust aspect ratio for Full SBS videos</li>
              </ul>
              <ul>
                <li>
                  [Optimization] Support more characters on virtual keyboard (¿
                  ¥ € ￡· ° | ` [ ]).
                </li>
              </ul>
              <ul>
                <li>[Optimization] Always play from last playback point.</li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="steam">
              <dt class="blog-title">
                Steam VR 0.2.0.2 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jul 22, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Fixed Bug] Fixed reverse video display with certain Fisheye
                  videos.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Display high resolution videos in Directory when
                  using RTX 2070 &amp; RTX 2080.
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="steam">
              <dt class="blog-title">
                Steam VR 0.2.0.1 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jun 28, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Fixed Bug] Black levels issue in the videos (dark was grey).
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="steam">
              <dt class="blog-title">
                Steam VR 0.2.0 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jan 09, 2019
                </span>
              </dt>
              <ul>
                <li>[Feature] Support deleting video files within SKYBOX.</li>
              </ul>
              <ul>
                <li>[Feature] View by List.</li>
              </ul>
              <ul>
                <li>
                  [Feature] Shortcuts to frequently-used folders (Pin Folder).
                </li>
              </ul>
              <ul>
                <li>[Feature] Sorting by Name/Size/Time.</li>
              </ul>
              <ul>
                <li>[Feature] Manually adapt to Youtube 360 (EAC).</li>
              </ul>
              <ul>
                <li>[Feature] Support Youtube 180 (Fisheye) videos.</li>
              </ul>
              <ul>
                <li>
                  [Feature] Display full filename when cursor hovers over a
                  video.
                </li>
              </ul>
              <ul>
                <li>
                  [Feature] Double click the controller button to pause and
                  resume playback.
                </li>
              </ul>
              <ul>
                <li>[Feature] New cinema scene "Moon".</li>
              </ul>
              <ul>
                <li>[Feature] Lighting adjustment in Movie Theatre Scene.</li>
              </ul>
              <ul>
                <li>[Feature] Seat change in Movie Theatre Scene.</li>
              </ul>
              <ul>
                <li>[Feature] SMB support.</li>
              </ul>
              <ul>
                <li>[Feature] Auto play next video on the playlist.</li>
              </ul>
              <ul>
                <li>
                  [Feature] Adjustment for eye distance (offset) for 3D videos.
                </li>
              </ul>
              <ul>
                <li>
                  [Feature] Support filling in SMB username/password using
                  keyboard.
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Upgrade player engine for improved playback
                  performance and compatibility.
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Optimize format recognition engine to improve
                  recognition accuracy.
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="steam">
              <dt class="blog-title">
                Steam VR 0.1.7 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jan 08, 2018
                </span>
              </dt>
              <dd class="blog-detail">
                Improved accuracy for automatic video stereo mode recognition.
              </dd>
              <dd class="blog-detail">Optimized long filename truncation.</dd>
              <dd class="blog-detail">
                Optimized screen scaling animation during playback.
              </dd>
            </dl>
          </div>
          <div class="dropdown-content-pc-client" style="display: none">
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.2.3 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Oct 31, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Fixed Bug] Fixed that videos cannot be played (show a
                  hourglass) sometimes.
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.2.2 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Feb 18, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Feature] Playback Speed Control
                  (0.1x/0.25x/0.5x/0.75x/1x/1.25x/1.5x/2x/4x).
                </li>
              </ul>
              <ul>
                <li>[Feature] AB Loop.</li>
              </ul>
              <ul>
                <li>[Feature] Order/Shuffle.</li>
              </ul>
              <ul>
                <li>[Feature] Loop Playlist / Loop One Vide / No Loop.</li>
              </ul>
              <ul>
                <li>
                  [Feature] Filename Recognition for Youtube 360 #EAC360 and
                  Youtube 180 #F180#VR180.
                </li>
              </ul>
              <ul>
                <li>
                  [Optimisation] Mute PC/Mac when turning off Screen Mirroring.
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.2.1 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jan 09, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Feature] Folder mode (allow organising files in folders).
                </li>
              </ul>
              <ul>
                <li>[Feature] Clear invalid files with one click.</li>
              </ul>
              <ul>
                <li>[Feature] Find file in Folder mode.</li>
              </ul>
              <ul>
                <li>[Feature] Open file physical location.</li>
              </ul>
              <ul>
                <li>[Feature] Select and remove more than one file.</li>
              </ul>
              <ul>
                <li>[Feature] Sort by Time.</li>
              </ul>
              <ul>
                <li>[Feature] List View.</li>
              </ul>
              <ul>
                <li>
                  [Optimization] Load files displayed on the current page first.
                </li>
              </ul>
              <ul>
                <li>[Optimisation] Load file first when clicking on it.</li>
              </ul>
              <ul>
                <li>[Fixed bug] Filename recognition for 2D and 3D videos.</li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.1.7.4 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Sep 19, 2018
                </span>
              </dt>
              <dd class="blog-detail">
                Fixed a javascript crashing bug for Windows.
              </dd>
              <dd class="blog-detail">
                Prevent computer from sleeping ONLY when videos are playing or
                devices connected.
              </dd>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.1.7.3 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jun 19, 2018
                </span>
              </dt>
              <dd class="blog-detail">Fixed some bugs.</dd>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.1.7.2 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} May 25, 2018
                </span>
              </dt>
              <dd class="blog-detail">Fixed a runtime error.</dd>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.1.7.1 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Apr 08, 2018
                </span>
              </dt>
              <dd class="blog-detail">Add support for iOS device.</dd>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.1.7 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jan 19, 2018
                </span>
              </dt>
              <dd class="blog-detail">Optimize video recognition process.</dd>
              <dd class="blog-detail">
                Optimize streaming for multiple devices.
              </dd>
            </dl>
            <dl class="blog-item" v-if="pc">
              <dt class="blog-title">
                PC / Mac Client 0.1.6 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Sep 14, 2017
                </span>
              </dt>
              <dd class="blog-detail">
                Videos can be played/paused/stopped in list view by context
                menu.
              </dd>
              <dd class="blog-detail">Moved orignal player to preview view.</dd>
              <dd class="blog-detail">
                Optimized search time for subtitles of large amount videos.
              </dd>
              <dd class="blog-detail">
                Optimized network connection for AirScreen.
              </dd>
              <dd class="blog-detail">Fixed several crashes.</dd>
              <dd class="blog-detail">
                Fixed video's info cannot be gotten in serveral types of video.
              </dd>
              <dd class="blog-detail">Fixed several UI bugs.</dd>
            </dl>
          </div>
          <div
            class="dropdown-content-oculus-rift-0-rift-s"
            style="display: none"
          >
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.2.3.4 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jan 17, 2020
                </span>
              </dt>
              <ul>
                <li>
                  [Feature] Global Setting (in the main hall where you could see
                  mountains outside, look up and a hidden bar would appear):
                </li>
              </ul>
              <ul>
                <li>a. Change language</li>
              </ul>
              <ul>
                <li>B. Clear cache</li>
              </ul>
              <ul>
                <li>c. Adjust fast forwards/backwards interval</li>
              </ul>
              <ul>
                <li>d. Spatial audio</li>
              </ul>
              <ul>
                <li>e. Screen mirroring</li>
              </ul>
              <ul>
                <li>f. Change to 24-hour format</li>
              </ul>
              <ul>
                <li>
                  [Feature] Support space button on keyboard to pause/resume
                </li>
              </ul>
              <ul>
                <li>[Feature] Support picture-based subtitles</li>
              </ul>
              <ul>
                <li>[Feature] Support subtitle font size adjustment</li>
              </ul>
              <ul>
                <li>[Feature] Refresh button on local directories</li>
              </ul>
              <ul>
                <li>
                  [Feature] Long press B/Y button to reset the screen (available
                  in Void/Moon/Space Station theatre and 180 videos)
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Do not generate thumbnails during video
                  playback
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Keep the browse location when deleting files or
                  return to parent directory
                </li>
              </ul>
              <ul>
                <li>
                  [Optimization] Continuous fast forwards/backwards video
                  playback by pushing the joystick to the right/left longer
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.2.1 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Nov 15, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Fixed Bug] Fixed some fisheye videos look blurry on the side.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed pixelation on red object during video
                  playback.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed certain 180 videos shoot by Insta360 could
                  be played once only.
                </li>
              </ul>
              <ul>
                <li>[Feature] New Advanced Settings:</li>
              </ul>
              <ul>
                <li>a. Curved Screen</li>
              </ul>
              <ul>
                <li>b. 3D L-R swap</li>
              </ul>
              <ul>
                <li>c. Playback Speed Adjustment</li>
              </ul>
              <ul>
                <li>d. AB loop</li>
              </ul>
              <ul>
                <li>f. Image Adjust - Contrast</li>
              </ul>
              <ul>
                <li>g. Image Adjust - Saturation</li>
              </ul>
              <ul>
                <li>h. Adjust aspect ratio for Full SBS videos</li>
              </ul>
              <ul>
                <li>
                  [Optimization] Support more characters on virtual keyboard (¿
                  ¥ € ￡· ° | ` [ ]).
                </li>
              </ul>
              <ul>
                <li>[Optimization] Always play from last playback point.</li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.2.0.2 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jul 22, 2019
                </span>
              </dt>
              <ul>
                <li>
                  [Optimization] Support manually change audio output between
                  Rift headphones and PC speaker.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Fixed reverse video display with certain Fisheye
                  videos.
                </li>
              </ul>
              <ul>
                <li>
                  [Fixed Bug] Display high resolution videos in Directory when
                  using RTX 2070 &amp; RTX 2080.
                </li>
              </ul>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.2.0.1 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jan 24, 2019
                </span>
              </dt>
              <dd class="blog-detail">
                [Fixed Bug] Black levels issue in the videos (dark was grey).
              </dd>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.2.0 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Nov 27, 2018
                </span>
              </dt>
              <dd class="blog-detail">Add cinema scene "Moon".</dd>
              <dd class="blog-detail">
                Lighting adjustment in the Movie Theatre Scene.
              </dd>
              <dd class="blog-detail">
                Seat change in the Movie Theatre Scene.
              </dd>
              <dd class="blog-detail">SMB support.</dd>
              <dd class="blog-detail">Support Youtube 180 (Fisheye) videos.</dd>
              <dd class="blog-detail">Auto play next video on the playlist.</dd>
              <dd class="blog-detail">Zoom boost to 350%.</dd>
              <dd class="blog-detail">
                Adjustment for eye distance (offset) for 3D videos.
              </dd>
              <dd class="blog-detail">
                Support filling in SMB username/password using keyboard.
              </dd>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.1.9 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Aug 13, 2018
                </span>
              </dt>
              <dd class="blog-detail">
                Upgrade player engine for improved playback performance and
                compatibility.
              </dd>
              <dd class="blog-detail">
                Optimize the format recognition engine to improve recognition
                accuracy.
              </dd>
              <dd class="blog-detail">
                Display entire filename when cursor hovers over a video.
              </dd>
              <dd class="blog-detail">
                Double click the controller button to pause and resume playback.
              </dd>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.1.8 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Feb 01, 2018
                </span>
              </dt>
              <dd class="blog-detail">
                Support deleting video files within SKYBOX.
              </dd>
              <dd class="blog-detail">
                Support the new list display mode for videos and folders.
              </dd>
              <dd class="blog-detail">
                Support creating folder shortcuts to the Channels.
              </dd>
              <dd class="blog-detail">
                Support sorting by file name, size, time in Directory.
              </dd>
              <dd class="blog-detail">
                Support manually adapting to YouTube-360-video format (EAC).
              </dd>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.1.7 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Jan 08, 2018
                </span>
              </dt>
              <dd class="blog-detail">
                Improved accuracy for automatic video stereo mode recognition.
              </dd>
              <dd class="blog-detail">Optimized long filename truncation.</dd>
              <dd class="blog-detail">
                Optimized screen scaling animation during playback.
              </dd>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.1.6 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Dec 07, 2017
                </span>
              </dt>
              <dd class="blog-detail">
                Support streaming videos from UPnP/DLNA servers.
              </dd>
              <dd class="blog-detail">
                Support hiding and locking all your private folds/files with one
                password.
              </dd>
              <dd class="blog-detail">
                Support manual time adjustment of audio and subtitles.
              </dd>
              <dd class="blog-detail">
                Support 'screen locking' with regular flatscreen videos to keep
                the screen always in front of you.
              </dd>
              <dd class="blog-detail">
                Optimized the UI of playback control panel for easier playback
                controls.
              </dd>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.1.4 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Nov 07, 2017
                </span>
              </dt>
              <dd class="blog-detail">Support Arabic and Hebrew subtitles.</dd>
              <dd class="blog-detail">
                Support playing videos with SKYBOX when browsing files with
                third party file management tools.
              </dd>
              <dd class="blog-detail">
                Fixed stutters during playback of MPEG2 and MPEG4 encoded
                videos.
              </dd>
            </dl>
            <dl class="blog-item" v-if="rift">
              <dt class="blog-title">
                Oculus Rift / Rift S 0.1.3 <br />
                <span class="release-time"
                  >{{ $t("m.get.release") }} Oct 07, 2017
                </span>
              </dt>
              <dd class="blog-detail">
                Support subtitles and audio track selection. (Subtitle files
                should be put under the same directory and has the same filename
                as the video.)
              </dd>
              <dd class="blog-detail">Support file directory browsing.</dd>
              <dd class="blog-detail">
                Added new theatre scene 'Space Station'.
              </dd>
              <dd class="blog-detail">
                Added new way to adjust the position (dragging) and size
                (sliding on touchpad) of the screen in the 'Void' theatre mode.
              </dd>
            </dl>
          </div>
        </section>
        <div class="overflow"></div>
      </article>
    </section>
  </section>
    <transition name="fade">
    <div class="topCover" v-if="this.onPc == true">
      <div class="alertbox" :class="{ zh: $t('m.lang') == 'zh' }">
        <div class="title">请在电脑端下载。</div>
        <div class="btn" @click="this.onPc = false">
          <a class="btn-mon"> Ok </a>
        </div>
      </div>
    </div>
  </transition>
  <transition name="fade">
    <div class="topCover" v-if="windowActive">
      <div class="innerbox" :class="{ zh: $t('m.lang') == 'zh' }">
        <div class="icon" @click="windowActive = false">
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
            <path
              d="M12 10.586l6.718-6.717a.5.5 0 0 1 .707 0l.707.707a.5.5 0 0 1 0 .707L13.414 12l6.717 6.718a.5.5 0 0 1 0 .707l-.707.707a.5.5 0 0 1-.707 0L12 13.414l-6.718 6.717a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 0 1 0-.707L10.586 12 3.868 5.282a.5.5 0 0 1 0-.707l.707-.707a.5.5 0 0 1 .707 0L12 10.586z"
            ></path>
          </svg>
        </div>
        <div class="title">{{ $t("m.get.innerBox.title") }}</div>
        <div class="container">
          <p style="padding-bottom: 15px">
            {{ $t("m.get.innerBox.containerOne") }}
          </p>

          <p>{{ $t("m.get.innerBox.containerTwo") }}</p>
          <p style="padding-bottom: 15px">
            {{ $t("m.get.innerBox.containerThree") }}
            <font-awesome-icon :icon="['fab', 'apple']" />
            {{ $t("m.get.innerBox.containerFour") }}
          </p>
        </div>
        <div class="btn">
          <a
            class="btn-mon"
            :href="downloadUrlMacArm64"
            @click="this.windowActive = false"
          >
            <span>{{ $t("m.get.innerBox.btnOne") }}</span>
            <!-- <img
              src="../assets/images/beta.png"
              alt=""
              srcset=""
              class="beta"
            /> -->
          </a>
          <a
            class="btn-pre"
            :href="downloadUrlMacX64"
            @click="this.windowActive = false"
            ><span>{{ $t("m.get.innerBox.btnTwo") }}</span></a
          >
        </div>
      </div>
    </div>
  </transition>
  <transition name="fade">
    <div class="topCover" v-if="windowActiveWin">
      <div
        class="win innerbox"
        :class="{ zh: $t('m.lang') == 'zh' }"
    
      >
        <div class="icon" @click="windowActiveWin = false">
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
            <path
              d="M12 10.586l6.718-6.717a.5.5 0 0 1 .707 0l.707.707a.5.5 0 0 1 0 .707L13.414 12l6.717 6.718a.5.5 0 0 1 0 .707l-.707.707a.5.5 0 0 1-.707 0L12 13.414l-6.718 6.717a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 0 1 0-.707L10.586 12 3.868 5.282a.5.5 0 0 1 0-.707l.707-.707a.5.5 0 0 1 .707 0L12 10.586z"
            ></path>
          </svg>
        </div>
        <div class="title" style="text-align: center">
          选择适合你的 PC 的 SKYBOX 客户端
        </div>

        <div class="btn">
          <a
            class="btn-mon"
            href="https://download.skybox.xyz/skybox-pc-client/SKYBOX_for_Windows_1.0.0.exe"
            @click="this.windowActiveWin = false"
          >
            <span>Win 10 & 更高版本</span>
            <!-- <img
              src="../assets/images/beta.png"
              alt=""
              srcset=""
              class="beta"
              style="margin: 8px 0 0 4px"
            /> -->
          </a>
          <a
            class="btn-pre"
            href="https://download.skybox.xyz/skybox-pc-client/SKYBOX_for_Windows_0.2.4.exe"
            @click="this.windowActiveWin = false"
            ><span>Win 7 & Win 8</span></a
          >
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import i18n from "../lang/index";
import { downloadUrlMacArm64, downloadUrlMacX64, downloadUrlWin } from '../constant';

export default {
  computed: {},
  data() {
    return {
      windowActive: false,
      windowActiveWin: false,
      fullWidth: document.documentElement.clientWidth,
      title: "所有平台",
      showVR: "",
      listHeight: "40",
      check: "all",
      quest: "true",
      steam: "true",
      pc: "true",
      rift: "true",
      go: "true",

      notes: [],
      notesCheck: "",
      onPc: false,

      downloadUrlMacArm64,
      downloadUrlMacX64,
      downloadUrlWin,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize); //监听窗口大小变化
    i18n.global.locale = "zh";
    zE("webWidget", "show"); //进到页面就启动组件
    zE("webWidget", "setLocale", "zh-CN"); //设置语言

    window.zESettings = {
      webWidget: {
        color: { theme: "#fed65d" },
        offset: { horizontal: "25px", vertical: "25px" },
        contactForm: {
          attachments: true,
          ticketForms: [
            {
              id: 1500003115541,
              title: false,
              subject: false,
              fields: [
                {
                  id: "description",
                  labels: {
                    "*": "测试",
                  },
                  hint: {
                    "zh-CN":
                      "如在使用中遇到任何问题，请描述问题本身和如何遇到问题的。如想要 SKYBOX 支持新的功能，请描述你的需求和使用场景。",
                  },
                  prefill: { "*": " " },
                },
              ],
            },
          ],
        },
      },
    };
  },
  mounted() {
    document.querySelector(".supportLi").style.color = "";
    this.getRelease();
    window.scrollTo({
      top: 0,
    });
    document.addEventListener("click", (e) => {
      let eveThree = document.querySelectorAll(".select")[0];
      if (this.listHeight == 229 && e.target != eveThree) {
        this.listHeight = 40;
      }
    });
  },
  beforeUnmount: function () {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    compare(property, desc) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        if (desc == true) {
          //升序
          return value1 - value2;
        } else {
          //降序
          return value2 - value1;
        }
      };
    },
    async getRelease() {
      await this.$http({
        url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
        method: "POST",
        data: {
          methods: "getSkyboxNote",
        },
      }).then((res) => {
        this.notes = res.data.Items;
        this.notes.sort(this.compare("Id", false));
      });
    },
    handleResize(event) {
      this.fullWidth = document.documentElement.clientWidth;
    },
     checkBro() {
      var browser = {
        versions: (function () {
          var u = navigator.userAgent,
            app = navigator.appVersion;
          return {
            //移动终端浏览器版本信息
            trident: u.indexOf("Trident") > -1, //IE内核
            presto: u.indexOf("Presto") > -1, //opera内核
            webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
            iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("iPad") > -1, //是否iPad
            webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
          };
        })(),
        language: (
          navigator.browserLanguage || navigator.language
        ).toLowerCase(),
      };

      //以下是调用方法
      if (browser.versions.mobile) {
        //判断是否是移动设备打开。browser代码在下面
        this.onPc = true;
        return false;
      } else {
        return true; //否则就是PC浏览器打开
      }
    },
    showWindow() {
      if (this.checkBro()) {
        this.windowActive = true;
      }
    },
    showWindowWin() {
      if (this.checkBro()) {
        this.windowActiveWin = true;
      }
    },
    openList() {
      if (this.listHeight < 229) {
        this.listHeight = 229;
      } else {
        this.listHeight = 40;
      }
    },
    checkOpt(type) {
      switch (type) {
        case "All":
          (this.check = "all"), (this.quest = true);
          this.daydream = true;
          this.steam = true;
          this.pc = true;
          this.rift = true;
          this.go = true;
          this.title = i18n.global.t("m.get.all");

          break;
        case "Quest":
          (this.check = "quest"), (this.quest = true);
          this.daydream = false;
          this.steam = false;
          this.pc = false;
          this.rift = false;
          this.go = false;
          this.title = "Oculus Quest";
          break;
        case "Steam":
          (this.check = "steam"), (this.quest = false);
          this.daydream = false;
          this.steam = true;
          this.pc = false;
          this.rift = false;
          this.go = false;
          this.title = "Steam VR";
          break;
        case "PC":
          (this.check = "pc"), (this.quest = false);
          this.daydream = false;
          this.steam = false;
          this.pc = true;
          this.rift = false;
          this.go = false;
          this.title = "PC / Mac Client";
          break;
        case "Rift":
          (this.check = "rift"), (this.quest = false);
          this.daydream = false;
          this.steam = false;
          this.pc = false;
          this.rift = true;
          this.go = false;
          this.title = "Oculus Rift / Rift S";
          break;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
@import "../assets/scss/get.scss";
</style>